export interface Bench {
  key: string;
  x: number;
  y: number;
  dir: 'right' | 'left';
}

const benches: Bench[] = [
  {
    key: '1',
    x: 4,
    y: 3,
    dir: 'left',
  },
  {
    key: '2',
    x: 13,
    y: 16,
    dir: 'left',
  },
  {
    key: '3',
    x: 19,
    y: 6,
    dir: 'left',
  },
  {
    key: '4',
    x: 26,
    y: 0,
    dir: 'left',
  },


  {
    key: '5',
    x: 10,
    y: 4,
    dir: 'right',
  },
  {
    key: '6',
    x: 9,
    y: 12,
    dir: 'right',
  },
  {
    key: '7',
    x: 19,
    y: 14,
    dir: 'right',
  },
  {
    key: '8',
    x: 24,
    y: 13,
    dir: 'right',
  },
  {
    key: '9',
    x: 29,
    y: 10,
    dir: 'right',
  },
  {
    key: '10',
    x: 32,
    y: 10,
    dir: 'right',
  },
];

export default benches;

